import {gql} from '@apollo/client';

export default gql`
  mutation deletePodlinkDomain($input: DeletePodlinkDomainInput!) {
    authed {
      success
    }
    deletePodlinkDomain(input: $input) {
      success
    }
  }
`;
